@if (purchaseShopOffers() && purchaseShopOffers().provider === 'Paypal') {
  <div>
    <form
      #paypalForm
      method="POST"
      action="/expresscheckout"
      target="openPopup">
      <input
        type="hidden"
        name="Token"
        [value]="purchaseShopOffers().response.token" />
      <input
        type="hidden"
        name="RateId"
        [value]="purchaseShopOffers().response.productId" />
      <input
        type="hidden"
        name="Location"
        value="BuyCoins" />
      <input
        type="submit"
        name="paypal_submit"
        id="paypal_submit"
        value="Button Paypal Form" />
    </form>
  </div>
}

@if (
  purchaseShopOffers() &&
  (purchaseShopOffers().provider === 'AppleAppStore' || purchaseShopOffers().provider === 'GooglePlay')
) {
  <div>
    <div #iapForm></div>
  </div>
}

<!-- ADD NEW DIV TO ADD A NEW PAYMENT PROVIDER <div *ngIf="purchase.provider == ''"></div> -->
